import { applyBossImageFallback } from '../../nikke-catalog/domain/bossImageResolver.js';

export function applyPracticeBossImageFallback(bosses = [], bossImageLookup = null) {
  return applyBossImageFallback(bosses, bossImageLookup);
}
